import React, { useEffect, useState } from "react";
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import './HomeButtons.css';

function MexicanHomeStateButton({ stateKey, stateName }) {
  // Read the initial state from localStorage
  const currentHomeMexicanState = localStorage.getItem('homeMexicanState');
  const [isHomeMexicanState, setIsHomeMexicanState] = useState(currentHomeMexicanState === stateKey);

  const handleHapticsClick = async (callback) => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      // Haptics might not be available in browser
    }
    callback();
  };

  useEffect(() => {
    // Listen for storage changes to update button state
    const handleStorageChange = () => {
      const newHomeMexicanState = localStorage.getItem('homeMexicanState');
      setIsHomeMexicanState(newHomeMexicanState === stateKey);
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check on component mount
    handleStorageChange();

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [stateKey]);

  const handleClick = async () => {
    handleHapticsClick(() => {
      const currentHome = localStorage.getItem('homeMexicanState');
      
      if (currentHome === stateKey) {
        // If this is already the home state, remove it
        localStorage.setItem('homeMexicanState', '');
        setIsHomeMexicanState(false);
      } else {
        // Set this state as the new home state
        localStorage.setItem('homeMexicanState', stateKey);
        setIsHomeMexicanState(true);
      }
      
      // Dispatch storage event to notify other components
      window.dispatchEvent(new Event('storage'));
    });
  };

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      fill="currentColor"
      className="home-button-icon"
      viewBox="0 0 16 16"
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      {isHomeMexicanState ? (
        // House with checkmark icon
        <>
          <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"/>
          <path d="m8 3.293 4.712 4.712A4.5 4.5 0 0 0 8.758 15H3.5A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"/>
          <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.707l.547.547 1.17-1.951a.5.5 0 1 1 .858.514Z"/>
        </>
      ) : (
        // House with plus icon
        <>
          <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h4a.5.5 0 1 0 0-1h-4a.5.5 0 0 1-.5-.5V7.207l5-5 6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"/>
          <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 1 0 1 0v-1h1a.5.5 0 1 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z"/>
        </>
      )}
    </svg>
  );
}

export default MexicanHomeStateButton;